import * as yup from 'yup';
export const meddiYup = {
	yesNoRadioList: () => {
		return yup
			.mixed()
			.oneOf([true, false], 'validation.form.choseOneOf')
			.nullable()
			.default(null);
	},
	selectRequired: (message: string) => {
		return yup
			.object({
				value: yup.string().nullable(),
				label: yup.string().nullable(),
			})
			.typeError(message)
			.test(
				'select-value-required',
				message,
				val => val != null && val.value != null && val.value !== undefined,
			);
	},
};
